// Minimal condition-token → label map for the SCANNED condition shown on the
// verify page. Mirrors the Cloud Function's CONDITION_LABELS (TD-28 family —
// unify when a shared package exists). Unknown/graded tokens pass through.
const CONDITION_LABELS: Record<string, string> = {
  RAW: 'Raw (Ungraded)',
  UNC: 'Uncirculated',
  CIRC: 'Circulated',
  VG: 'Very Good',
  VF: 'Very Fine',
  XF: 'Extremely Fine',
  EF: 'Extremely Fine',
  AU: 'About Uncirculated',
  MS: 'Mint State',
};

export function conditionLabel(token: string | null | undefined): string | null {
  if (!token) return null;
  const t = String(token).toUpperCase();
  return CONDITION_LABELS[t] || t;
}
